<ul class="list">
  <li
    *ngFor="let file of files"
    class="card"
  >
    <div
      class="card__content"
      [class.card__content--pdf]="!hasFileErrors(file) && file.nativeFile.type === mimeType.pdf"
    >
      <div class="loading" *ngIf="file.isLoading">
        <svg class="loading__spinner">
          <circle class="loading__path" cx="25" cy="25" r="20"></circle>
        </svg>
      </div>
      <ng-container
        *ngIf="!hasFileErrors(file) || file.secureImageSrc"
        [ngSwitch]="file.nativeFile.type"
      >
        <img
          *ngSwitchCase="mimeType.pdf"
          [alt]="file.nativeFile.name"
          class="icon-pdf"
          src="./assets/img/icons/i-pdf.svg"
        />
        <div
          *ngSwitchDefault
          class="thumbnail"
          [class.overlay]="!file.isLoading && settings.uploadUrl && file.errors?.load"
        >
          <img *ngIf="file.secureImageSrc" [src]="file.secureImageSrc" [alt]="file.nativeFile.name" />
        </div>
      </ng-container>
      <icon
        (click)="onImageFileDelete(file)"
        class="delete"
        src="./assets/img/icons/i-search-cancel.svg"
        height="22px"
        width="22px"
      ></icon>
      <icon
        *ngIf="file.isLoaded"
        class="check"
        src="./assets/img/icons/i-check.svg"
        color="#FFFFFF"
        height="15px"
        width="21px"
      ></icon>
      <icon
        *ngIf="!file.isLoading && settings.uploadUrl && file.errors?.load"
        (click)="handleFileWithServerUpload(file)"
        class="retry"
        color="#FFFFFF"
        height="24px"
        name="loader"
        width="24px"
      ></icon>
      <icon
        *ngIf="!file.isLoading && !file.secureImageSrc && hasFileErrors(file)"
        src="./assets/img/icons/file-attach/wrong.svg"
        width="50px"
        height="34px"
      ></icon>
    </div>
    <ng-container *ngIf="file.errors">
      <span
        *ngIf="file.errors.type"
        class="error-input"
        [innerHTML]="'profile-identity.error.files.type' | translate: { formats: allowedFileTypes }"
      ></span>
      <span
        *ngIf="file.errors.size"
        class="error-input"
        translate="profile-identity.error.files.size"
        [translateParams]="{ size: file.nativeFile.type === settings.customFileParameters?.type ? settings.customFileParameters.maxSize / (1024*1024) : settings.allowedFileSize / (1024*1024) }"
      ></span>
      <span
        *ngIf="file.errors.dimensions"
        class="error-input"
        translate="profile-identity.error.files.dimensions"
      ></span>
      <span
        *ngIf="file.errors.load"
        class="error-input"
        translate="profile-identity.error.files.load"
      ></span>
    </ng-container>
  </li>

  <li
    #dropArea
    class="card"
    [class.hidden]="files.length >= settings.maxFiles"
  >
    <div class="card__content">
      <label class="click-zone">
        <input
          #fileInput
          (change)="attachFiles($event.target)"
          (click)="downloadLabelClicked.next()"
          [multiple]="settings.maxFiles !== 1"
          [accept]="settings.allowedContentTypes"
          autocomplete="files"
          data-e2e-element="file-input"
          hidden
          name="file"
          type="file"
        />
        <input
          (click)="fileInput.click()"
          [formControl]="ctrl"
          hidden
        />
        <svg width="72" height="72">
          <circle r="36" cx="36" cy="36" fill="#fff"></circle>
          <path d="M37.2 37.8h11v-2h-11V24h-2v11.9H24.4v1.9h11v11.9h2v-12Z"/>
        </svg>
      </label>
    </div>
    <p *ngIf="uploadText" class="card__text" [translate]="uploadText"></p>
  </li>
</ul>

<ng-container *ngIf="ctrl && ctrl.errors && (ctrl.dirty || ctrl.touched)">
  <div
    *ngIf="ctrl.errors['maxFiles']"
    class="error-input"
    translate="profile-identity.error.files.count"
    [translateParams]="{ count: settings.maxFiles }"
  ></div>
</ng-container>
